import { useMutation, gql } from '@apollo/react-hooks';
import { useCallback } from 'react';
import type { UpdateTenantMutation, Tenant, TenantInput } from '#/graphql/types';
import { updateTenant } from '#/graphql/mutations'
import { get, omit, pick } from 'lodash';

const q = gql(updateTenant);

const useTenantUpdate = () => {
    const [mutation, result] = useMutation<UpdateTenantMutation>(q);
    const updateTenant = useCallback(
        async (itemId: string, tenant: TenantInput) => {
            const response = await mutation({
                variables: {
                    id: itemId,
                    data: pick(tenant, ['name', 'address', 'contacts', 'cognitoGroupName', 'tisId', 'plan', 'isActive']),
                },
            });
            return get(response, 'data.updateTenant', undefined);
        },
        [mutation],
    );

    return { updateTenant, result };
};
// Used in the modules Form file
export default useTenantUpdate;